function Landing() {
  return (
    <main>
      {/* Hero */}
      <section className="hero">
        <h1>
          Your documents,{' '}
          <span className="gradient-text">secured.</span>
        </h1>
        <p className="hero-subtitle">
          Encrypted. Organised. Always with you. Store your passports, visas,
          and identity documents in a vault only you can access.
        </p>
        <a
          href="https://apps.apple.com/app/doccy/id6761733368"
          className="hero-cta"
        >
          Download on the App Store
        </a>
      </section>

      {/* Features */}
      <section className="features">
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">📷</div>
            <h3>Scan & Go</h3>
            <p>
              Point your camera at any passport and Doccy reads the MRZ
              automatically. Name, number, nationality, dates — filled in instantly.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔗</div>
            <h3>Everything Linked</h3>
            <p>
              Visas, ESTAs, ETAs, and trusted traveller memberships are linked
              to the passport they belong to. When a passport expires, Doccy knows.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔒</div>
            <h3>Encrypted by Default</h3>
            <p>
              AES-256-GCM encryption. No servers. No accounts. No tracking.
              Your data is encrypted before it touches storage.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🧬</div>
            <h3>Face ID Protected</h3>
            <p>
              The vault locks every time you leave the app. Only your face
              or fingerprint can open it.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔔</div>
            <h3>Smart Reminders</h3>
            <p>
              Get notified before any document expires. If your passport is
              expiring, Doccy warns you about linked visas too.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📄</div>
            <h3>Not Just Passports</h3>
            <p>
              Driving licences, national IDs, travel insurance, vaccination
              records, green cards — all encrypted, all in one place.
            </p>
          </div>
        </div>
      </section>

      {/* Security Banner */}
      <section className="security-banner">
        <h2>Zero-knowledge security</h2>
        <p>
          Your data is encrypted with AES-256-GCM before it ever touches
          storage. No servers, no accounts, no tracking. Not even we can
          see your data — because we never have it.
        </p>
        <div className="security-badges">
          <span className="security-badge">🔐 AES-256-GCM</span>
          <span className="security-badge">🧬 Face ID / Touch ID</span>
          <span className="security-badge">📱 On-device only</span>
          <span className="security-badge">☁️ Encrypted iCloud sync</span>
        </div>
      </section>

      {/* Pro Section */}
      <section className="pro-section">
        <span className="pro-badge">PRO</span>
        <h2>Doccy Pro</h2>
        <p>Unlock the full power of Doccy with a one-time purchase.</p>
        <div className="pro-features">
          <div className="pro-feature">
            <span>♾️ Unlimited documents</span>
          </div>
          <div className="pro-feature">
            <span>🔔 Expiry reminders</span>
          </div>
          <div className="pro-feature">
            <span>☁️ iCloud sync</span>
          </div>
          <div className="pro-feature">
            <span>🔄 Cascade alerts</span>
          </div>
        </div>
        <a
          href="https://apps.apple.com/app/doccy/id6744145782"
          className="hero-cta"
        >
          Get Doccy Pro
        </a>
      </section>
    </main>
  );
}

export default Landing;
